/**
 * Anubis Lazy Sections — Intersection Observer for below-fold sections.
 * Adds `is-visible` class when section enters viewport, enabling CSS animations.
 * Also defers loading of heavy media (carousels, iframes) until visible.
 */

(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  const THRESHOLD = 0.08;
  const ROOT_MARGIN = '0px 0px -40px 0px';

  // 1. Fade-in observer — applies to any section with data-lazy-section
  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: THRESHOLD, rootMargin: ROOT_MARGIN }
  );

  document.querySelectorAll('[data-lazy-section]').forEach((el) => {
    el.classList.add('lazy-section');
    fadeObserver.observe(el);
  });

  // 2. Deferred iframe/video observer — loads src only when visible
  const mediaObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;

        // Lazy iframe (e.g. YouTube embeds)
        if (el.tagName === 'IFRAME' && el.dataset.src) {
          el.src = el.dataset.src;
          delete el.dataset.src;
        }

        // Lazy video source
        if (el.tagName === 'VIDEO') {
          el.querySelectorAll('source[data-src]').forEach((s) => {
            s.src = s.dataset.src;
            delete s.dataset.src;
          });
          el.load();
        }

        mediaObserver.unobserve(el);
      });
    },
    { threshold: 0.01, rootMargin: '200px 0px' }
  );

  document.querySelectorAll('iframe[data-src], video:has(source[data-src])').forEach((el) => {
    mediaObserver.observe(el);
  });

  // Re-run on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-lazy-section]:not(.lazy-section)').forEach((el) => {
      el.classList.add('lazy-section');
      fadeObserver.observe(el);
    });
  });
})();
